// selectors.js
import { validateName, validateBirthdate } from '../validations';
import { validatePhone, validateEmail } from 'migration-flos-react';

// get the state of this store
const selectState = (state) => state.form;
const selectUiState = (state) => state.ui;

/**
 * @returns {object}
 */
export const selectResources = (state) => selectUiState(state).resources;

/**
 * @returns {string}
 */
export const selectUiStatus = (state) => selectUiState(state).uiStatus;

/**
 * @returns {boolean}
 */
export const selectDisplayError = (state) => selectUiState(state).displayError;

/**
 * @returns {number}
 */
export const selectFormStep = (state) => selectUiState(state).formStep;

/**
 * @returns {boolean}
 */
export const selectIsSubmitting = (state) => selectUiState(state).isSubmitting;

export const selectErrorText = (state) => selectUiState(state).errorText;

export const selectSubmitEndpoint = (state) => selectUiState(state).submitEndpoint;

export const selectSubmitInsuranceGuideEndpoint = (state) => selectUiState(state).submitInsuranceGuideEndpoint;

export const selectReceiptEndpoint = (state) => selectUiState(state).receiptEndpoint;

export const selectPostFormData = (state) => selectUiState(state).postFormData;

export const selectFlow = (state) => selectUiState(state).flow;

export const selectInsurances = (state) => selectState(state).insurances;

export const selectAdditionalInfo = (state) => selectState(state).additionalInfo;

export const selectShowInsurances = (state) => selectUiState(state).showInsurances;

export const selectOpenTimesEndpoint = (state) => selectUiState(state).openTimesEndpoint;

export const selectOpeningTimes = (state) => selectUiState(state).openingTimes;

export const selectSubmitGenesysEndpoint = (state) => selectUiState(state).submitGenesysEndpoint;

/**
 * @returns {string}
 */
export const selectName = (state) => selectState(state).name;

export const selectIsNameValid = (state) => validateName(selectName(state));

/**
 * @returns {string}
 */
export const selectBirthdate = (state) => selectState(state).birthdate;

export const selectIsBirthdateValid = (state) => validateBirthdate(selectBirthdate(state));

/**
 * @returns {string}
 */
export const selectAddress = (state) => selectState(state).address;

export const selectIsAddressValid = (state) => selectState(state).isAddressValid;

/**
 * @returns {string}
 */
export const selectMobile = (state) => selectState(state).mobile;

export const selectIsMobileValid = (state) => validatePhone(selectMobile(state));

/**
 * @returns {string}
 */
export const selectEmail = (state) => selectState(state).email;

export const selectIsEmailValid = (state) => validateEmail(selectEmail(state));

/**
 * @returns {string}
 */
export const selectContactOption = (state) => selectState(state).contactOption;

/**
 * @returns {string}
 */
export const selectContactDateTimeOption = (state) => selectState(state).contactDateTimeOption;

/**
 * @returns {string}
 */
export const selectContactDate = (state) => selectState(state).contactDate;

/**
 * @returns {string}
 */
export const selectContactTime = (state) => selectState(state).contactTime;

/**
 * @returns {string}
 */
export const selectMinimal = (state) => selectState(state).minimal;

export const selectContactTimeEnd = (state) => {
    const minsToAdd = 15;
    const endTime = new Date(
        new Date('1970/01/01 ' + selectContactTime(state)).getTime() + minsToAdd * 60000
    ).toLocaleTimeString('en-UK', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
    return endTime;
};

export const isValid = (state) => {
    let output = false;
    if (selectContactOption(state) !== '') {
        if (selectContactOption(state) !== '') {
            if (
                selectContactDateTimeOption(state) === '0' ||
                (selectContactDate(state) !== '' && selectContactTime(state) !== '')
            ) {
                output = true;
            }
        }
    }
    return output;
};

export const selectIsFormValid = (state) => {
    return (
        selectIsNameValid(state) &&
        selectIsEmailValid(state) &&
        selectIsAddressValid(state) &&
        selectIsBirthdateValid(state) &&
        selectIsMobileValid(state) &&
        selectContactOption(state) !== '' &&
        isValid(state)
    );
};
